import {html} from 'lit-html';
import templateProjectFilterContainer from './template-project-filter-container';
import templateProjectResultContainer from './template-project-result-container';

const template = (data) => html`
<div class="project-offer-container" data-projects-loaded="${data.isProjectsLoaded()}">
	${templateProjectFilterContainer(data)}
	${templateProjectResultContainer(data)}
</div>`;

export default template;